import { createSelector } from 'reselect';
import { PAGE_INDICES } from '../../actions/eaTravelRates/types';
import { getEaTravelRates } from './index';

const getRouting = createSelector(getEaTravelRates, (state) => state.routing);

export const getActivePageIndex = createSelector(getRouting, (routing) => routing.activePageIndex);
export const getDoTravelInsuranceNavigation = createSelector(getRouting, (routing) => routing.doNavigation);
export const getDoExitMotorInsuranceNavigation = createSelector(getRouting, (routing) => routing.doExitNavigation);

const makeGetIsPage = (pageIndex) => createSelector(getRouting, (routing) => routing.activePageIndex === pageIndex);
export const getIsLoginPage = makeGetIsPage(PAGE_INDICES.LOGIN);
export const getIsUpdatePage = makeGetIsPage(PAGE_INDICES.UPDATE);

export const getProgressBarIndex = createSelector(getIsLoginPage, getIsUpdatePage, (isLoginPage, isUpdatePage) => {
    if (isLoginPage) return 0;
    if (isUpdatePage) return 1;
});
